import { PieChart, Pie, Cell, Text } from "recharts";
import { CHART_COLORS, PeriodsProgressCircleLabelOverlayProps } from "../ChartSettings";
import "./PeriodsCircleOverlay.scss";
import { getFullMonth } from "../../../util/period";
import { storedLocale } from "../../../../components/Authentication/util";

const getTextColor = (index: number, numFilledSlices: number, disabled: boolean): string => {
  if (disabled) {
    // For exempt state, use different colors based on segment type
    const isPartiallyFilled = index + 1 === Math.floor(numFilledSlices + 1) && (numFilledSlices + 1) % 1 >= 0.5;
    const isFullyFilled = index + 1 <= numFilledSlices;

    // On Track segments get white text, others get gray text
    return isPartiallyFilled || isFullyFilled ? "#ffffff" : "#707070";
  }

  const isPartiallyFilled = index + 1 === Math.floor(numFilledSlices + 1) && (numFilledSlices + 1) % 1 >= 0.5;
  const isFullyFilled = index + 1 <= numFilledSlices;

  return isPartiallyFilled || isFullyFilled ? "white" : CHART_COLORS.black;
};

export const PeriodsProgressCircleLabelOverlay = ({
  numFilledSlices,
  period,
  currentVolumeFill,
  currentAmount,
  targetAmount,
  disabled,
  chartTitle,
}: PeriodsProgressCircleLabelOverlayProps) => {
  const months = ["09", "10", "11", "12", "01", "02", "03", "04", "05", "06", "07", "08"];
  const data = months.map((month) => {
    return { name: month, value: 1, color: CHART_COLORS.black };
  });

  return (
    <div className="PeriodsCircleOverlay">
      <PieChart width={222} height={222}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          startAngle={90}
          endAngle={-270}
          innerRadius={70}
          outerRadius={100}
          dataKey="value"
          animationBegin={0}
          animationDuration={0}
          isAnimationActive={false}
          labelLine={false}
          legendType="none"
          label={({ cx, cy, midAngle, innerRadius, outerRadius, name, index }) => {
            const RADIAN = Math.PI / 180;
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-Number(midAngle) * RADIAN);
            const y = cy + radius * Math.sin(-Number(midAngle) * RADIAN);

            const color = getTextColor(Number(index), numFilledSlices, disabled);

            return (
              <Text
                x={x}
                y={y}
                fill={color}
                textAnchor="middle"
                dominantBaseline="central"
                fontSize={12}
                fontWeight={900}
              >
                {name}
              </Text>
            );
          }}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill="transparent" stroke="white" strokeWidth={2} />
          ))}
        </Pie>
      </PieChart>
      <div className="PeriodsCircleOverlay__innerCircleLblContainer">
        {chartTitle ? (
          <>{chartTitle}</>
        ) : (
          <>
            <h3 className={disabled ? `PeriodsCircleOverlay--disabled` : ""}>{getFullMonth(period, storedLocale())}</h3>
            <p className={disabled ? `PeriodsCircleOverlay--disabled` : ""}>
              <span
                className="PeriodsCircleOverlay__currentAmount"
                style={{
                  color: disabled ? CHART_COLORS.disabled : currentVolumeFill,
                }}
              >
                {currentAmount.formatted}
              </span>
              <span>
                <span className="PeriodsCircleOverlay__volDivider">/</span>
                {targetAmount.formatted}
              </span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};
